
// 国内电话号码
export const CHINA_MOBILE = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/;
// 自然数
export const COMMON_NUMBER = /^\d+(\.\d+)?$/;
// 银行卡号
export const BANK_NUMBER = /^[0-9]{16,19}$/;
// 正负实数
export const ALL_NUMBER = /^(\-|\+)?\d+(\.\d+)?$/;
// 密码格式（至少一个字母 至少一个数字 共6-16位）
export const PASSWORD = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,16}$/;
// 电话数字 手机号+固话 只限制数字和部分字符
export const PHONE_NUMBER = /^[0-9\-\+]*$/;
//正则地址
export function RegAddress(str){
    let regu = /^[a-zA-Z0-9_\u4e00-\u9fa5]+[^;=?+$\x22]+$/;
    let re = new RegExp(regu);
    return re.test(str)
} 
//正则姓名 验证是否含有特殊符号
export function RegName(str){
    let regu = /^[a-zA-Z0-9_\u4e00-\u9fa5]+[^;=?+$\x22]+$/;
    let re = new RegExp(regu);
    return re.test(str)
}  

// 验证手机号码
export function RegPhone(str) {
    let regu = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/; 
    let re = new RegExp(regu);
    return re.test(str);
} 
